import React, { useEffect, useState } from 'react';
import { supabase } from '../supabase';

// Prévia do certificado oficial na tela (o PDF de verdade sai do modelo HTML).
// Fundo: imagens oficiais (api/_modelos/fundo-*.png, só para quem está logado) + textos
// por cima nas mesmas posições do modelo. Medidas em % e letras em cqw (acompanham o card).

const fundos = {};
function useFundo(lado) {
  const [url, setUrl] = useState(fundos[lado]?.url || '');
  useEffect(() => {
    let vivo = true;
    if (!fundos[lado]) {
      fundos[lado] = {
        promessa: supabase.auth.getSession()
          .then(({ data: { session } }) => fetch(`/api/certificado-fundo?lado=${lado}`, { headers: { Authorization: `Bearer ${session?.access_token}` } }))
          .then(r => (r.ok ? r.blob() : Promise.reject(new Error(String(r.status)))))
          .then(b => { fundos[lado].url = URL.createObjectURL(b); return fundos[lado].url; })
          .catch(() => { delete fundos[lado]; return ''; }),
      };
    }
    fundos[lado].promessa?.then(u => { if (vivo) setUrl(u); });
    return () => { vivo = false; };
  }, [lado]);
  return url;
}

const abs = (top, extra = {}) => ({ position: 'absolute', top: `${top}%`, left: 0, right: 0, textAlign: 'center', ...extra });

export default function CertificadoPrevia({ lado = 'frente', d }) {
  const fundo = useFundo(lado);
  const caixa = {
    position: 'relative', width: '100%', aspectRatio: '2000 / 1414', containerType: 'inline-size',
    background: fundo ? `center/cover no-repeat url(${fundo})` : '#f3f1ea', borderRadius: 8, overflow: 'hidden',
    boxShadow: '0 6px 18px -10px rgba(16,35,59,.35)', color: '#2b2f3a', fontFamily: "'Open Sans', system-ui, sans-serif",
  };
  if (lado === 'verso') {
    const Campo = ({ r, v, x, w, y }) => (
      <div style={{ position: 'absolute', left: `${x}%`, width: `${w}%`, top: `${y}%`, borderBottom: '0.12cqw solid #c9cde0', paddingBottom: '0.4cqw' }}>
        <div style={{ fontSize: '1.2cqw', fontFamily: 'Georgia, serif' }}>{r}</div>
        <div style={{ fontSize: '1.05cqw', fontFamily: 'Georgia, serif', marginTop: '0.4cqw', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{v}</div>
      </div>
    );
    return (
      <div style={caixa}>
        <div style={abs(10, { fontSize: '2cqw', fontWeight: 700, letterSpacing: '.03em' })}>REGISTRO DE CONCLUSÃO DE CURSO</div>
        <Campo r="Aluno" v={d.alunoNome} x={8} w={55} y={19} />
        <Campo r="CPF" v={d.cpf || '—'} x={65} w={27} y={19} />
        <Campo r="Curso" v={d.cursoTitulo} x={8} w={55} y={27.5} />
        <Campo r="Responsável pelo curso" v={d.responsavel} x={65} w={27} y={27.5} />
        <Campo r="Início" v={d.inicio} x={8} w={12.5} y={36} />
        <Campo r="Conclusão" v={d.fim} x={22.3} w={12.5} y={36} />
        <Campo r="Carga Horária" v={d.cargaHoraria} x={36.6} w={12.5} y={36} />
        <Campo r="Frequência" v={d.frequencia} x={50.8} w={12.5} y={36} />
        <Campo r="Média Final" v={d.nota} x={65} w={12.5} y={36} />
        <Campo r="Média Mínima" v={d.notaMinima} x={79.3} w={12.5} y={36} />
        <div style={{ position: 'absolute', left: '8%', width: '55%', top: '46%', textAlign: 'left' }}>
          <div style={{ fontSize: '1.7cqw', marginBottom: '0.8cqw' }}>Conteúdo abordado:</div>
          <ul style={{ margin: 0, paddingLeft: '2.2cqw', fontSize: '1.1cqw', lineHeight: 1.6, fontFamily: 'Georgia, serif' }}>
            {(d.modulos?.length ? d.modulos : ['Conteúdo do curso']).slice(0, 12).map((m, i) => <li key={i}>{m}</li>)}
          </ul>
        </div>
        <div style={{ position: 'absolute', left: '68%', width: '24%', top: '46%', height: '38%', background: '#fff', border: '0.12cqw solid #d6dae6', borderRadius: '1cqw', textAlign: 'center', padding: '1.4cqw 0.6cqw', boxSizing: 'border-box' }}>
          <div style={{ fontSize: '0.95cqw', fontWeight: 700, letterSpacing: '.12em', color: '#2b3866' }}>AUTENTICIDADE</div>
          <div style={{ fontSize: '0.9cqw', color: '#6b7280', marginTop: '6cqw' }}>Código de verificação</div>
          <div style={{ fontSize: '1.2cqw', fontWeight: 700 }}>{d.codigo}</div>
          <div style={{ fontSize: '0.9cqw', color: '#6b7280', marginTop: '0.8cqw' }}>Emitido em</div>
          <div style={{ fontSize: '1.05cqw', fontWeight: 700 }}>{d.cidade}, {d.dataEmissao}</div>
        </div>
      </div>
    );
  }
  return (
    <div style={caixa}>
      <div style={{ position: 'absolute', top: '18.4%', left: '22.3%', width: '55.3%', height: '5.4%', background: '#172463', borderRadius: '0.5cqw', color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: 'Georgia, serif', fontSize: '2.3cqw', padding: '0 1cqw', boxSizing: 'border-box', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{d.cursoTitulo}</div>
      <div style={{ position: 'absolute', top: '23.6%', left: '79.5%', width: '14%', textAlign: 'center', color: '#d9653b', fontSize: '1.15cqw' }}>Nº {d.codigo}</div>
      <div style={abs(32.5, { fontSize: '1.7cqw' })}>Certificamos que</div>
      <div style={abs(37, { fontSize: '2.9cqw', fontWeight: 700, color: '#26335f' })}>{d.alunoNome}</div>
      {d.cpf && <div style={abs(43, { fontSize: '1.1cqw', color: '#6b7280' })}>CPF {d.cpf}</div>}
      <div style={abs(47.5, { left: '15%', right: '15%', fontSize: '1.45cqw', lineHeight: 1.5 })}>
        concluiu o curso livre acima, na modalidade a distância assíncrona, no Ambiente Virtual de Aprendizagem do INEP, no período de {d.inicio} a {d.fim}, com carga horária de {d.cargaHoraria}, frequência de {d.frequencia} e média final {d.nota}.
      </div>
      <div style={abs(60.5, { fontSize: '1.35cqw' })}>{d.cidade}, {d.dataEmissao}.</div>
      <div style={abs(80.5, { fontSize: '0.95cqw', color: '#4b5563' })}>Código: <b>{d.codigo}</b></div>
    </div>
  );
}
